/**
 * The node's own tag, or null when it has none. A tag that only restates the
 * node number ("Node 12", or "Tree 12" since the UI says tree) counts as none: the node page used to save that
 * placeholder as a real tag, so reports printed "12 (Node 12)" and the site
 * map couldn't shorten labels to the bare number. Treating it as unset here
 * cleans up every such row without a data migration.
 */
export function customNodeTag(node: {
  node_number: number
  node_tag?: string | null
}): string | null {
  const tag = node.node_tag?.trim()
  if (!tag) return null
  const lower = tag.toLowerCase()
  return lower === `node ${node.node_number}` || lower === `tree ${node.node_number}` ? null : tag
}
